/* svelte-comps/Video.svelte generated by Svelte v3.59.1 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_data,
	set_style,
	space,
	text,
	toggle_class
} from "svelte/internal";

import moment from 'moment';

function create_if_block_2(ctx) {
	let h5;
	let t_value = /*formatDate*/ ctx[3](/*video*/ ctx[0].post_date) + "";
	let t;

	return {
		c() {
			h5 = element("h5");
			t = text(t_value);
			attr(h5, "class", "video-date pow-h5");
		},
		m(target, anchor) {
			insert(target, h5, anchor);
			append(h5, t);
		},
		p(ctx, dirty) {
			if (dirty & /*video*/ 1 && t_value !== (t_value = /*formatDate*/ ctx[3](/*video*/ ctx[0].post_date) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(h5);
		}
	};
}

// (39:6) {#if show_category === true && video.category}
function create_if_block_1(ctx) {
	let h5;
	let t_value = /*video*/ ctx[0].category.replace('-', ' ') + "";
	let t;

	return {
		c() {
			h5 = element("h5");
			t = text(t_value);
			attr(h5, "class", "video-date pow-h5");
		},
		m(target, anchor) {
			insert(target, h5, anchor);
			append(h5, t);
		},
		p(ctx, dirty) {
			if (dirty & /*video*/ 1 && t_value !== (t_value = /*video*/ ctx[0].category.replace('-', ' ') + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(h5);
		}
	};
}

// (42:6) {#if video.author != 'No Author'}
function create_if_block(ctx) {
	let p;
	let t0;
	let t1_value = /*video*/ ctx[0].author + "";
	let t1;

	return {
		c() {
			p = element("p");
			t0 = text("By: ");
			t1 = text(t1_value);
			attr(p, "class", "video-author");
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t0);
			append(p, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*video*/ 1 && t1_value !== (t1_value = /*video*/ ctx[0].author + "")) set_data(t1, t1_value);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

function create_fragment(ctx) {
	let li;
	let div1;
	let a0;
	let a0_href_value;
	let t0;
	let div0;
	let t1;
	let a1;
	let h4;
	let t2_value = /*video*/ ctx[0].post_title + "";
	let t2;
	let a1_href_value;
	let t3;
	let t4;
	let mounted;
	let dispose;
	let if_block0 = /*video*/ ctx[0].show_date === true && create_if_block_2(ctx);
	let if_block1 = /*show_category*/ ctx[1] === true && /*video*/ ctx[0].category && create_if_block_1(ctx);
	let if_block2 = /*video*/ ctx[0].author != 'No Author' && create_if_block(ctx);

	return {
		c() {
			li = element("li");
			div1 = element("div");
			a0 = element("a");
			t0 = space();
			div0 = element("div");
			if (if_block0) if_block0.c();
			t1 = space();
			a1 = element("a");
			h4 = element("h4");
			t2 = text(t2_value);
			t3 = space();
			if (if_block1) if_block1.c();
			t4 = space();
			if (if_block2) if_block2.c();
			attr(a0, "class", "video-image lazyload");
			set_style(a0, "background-image", "url('" + /*video*/ ctx[0].thumbnail_url + "')");
			attr(a0, "href", a0_href_value = "/video/" + /*video*/ ctx[0].post_name);
			toggle_class(a0, "hover", /*isHovered*/ ctx[2]);
			attr(h4, "class", "video-title pow-h4");
			attr(a1, "href", a1_href_value = "/video/" + /*video*/ ctx[0].post_name);
			attr(div0, "class", "video-info");
			attr(div1, "class", "video-container");
			attr(li, "class", "video-item");
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, div1);
			append(div1, a0);
			append(div1, t0);
			append(div1, div0);
			if (if_block0) if_block0.m(div0, null);
			append(div0, t1);
			append(div0, a1);
			append(a1, h4);
			append(h4, t2);
			append(div0, t3);
			if (if_block1) if_block1.m(div0, null);
			append(div0, t4);
			if (if_block2) if_block2.m(div0, null);

			if (!mounted) {
				dispose = [
					listen(a1, "mouseenter", /*hover*/ ctx[4]),
					listen(a1, "mouseleave", /*hoverExit*/ ctx[5])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*video*/ 1) {
				set_style(a0, "background-image", "url('" + /*video*/ ctx[0].thumbnail_url + "')");
			}

			if (dirty & /*video*/ 1 && a0_href_value !== (a0_href_value = "/video/" + /*video*/ ctx[0].post_name)) {
				attr(a0, "href", a0_href_value);
			}

			if (dirty & /*isHovered*/ 4) {
				toggle_class(a0, "hover", /*isHovered*/ ctx[2]);
			}

			if (/*video*/ ctx[0].show_date === true) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_2(ctx);
					if_block0.c();
					if_block0.m(div0, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (dirty & /*video*/ 1 && t2_value !== (t2_value = /*video*/ ctx[0].post_title + "")) set_data(t2, t2_value);

			if (dirty & /*video*/ 1 && a1_href_value !== (a1_href_value = "/video/" + /*video*/ ctx[0].post_name)) {
				attr(a1, "href", a1_href_value);
			}

			if (/*show_category*/ ctx[1] === true && /*video*/ ctx[0].category) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_1(ctx);
					if_block1.c();
					if_block1.m(div0, t4);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (/*video*/ ctx[0].author != 'No Author') {
				if (if_block2) {
					if_block2.p(ctx, dirty);
				} else {
					if_block2 = create_if_block(ctx);
					if_block2.c();
					if_block2.m(div0, null);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(li);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { video, show_category } = $$props;
	let isHovered = false;

	// Moment Date format matches php 'F, j, Y'
	const formatDate = dateString => moment(dateString).format('MMMM D, YYYY');

	const hover = () => {
		$$invalidate(2, isHovered = true);
	};

	const hoverExit = () => {
		$$invalidate(2, isHovered = false);
	};

	$$self.$$set = $$props => {
		if ('video' in $$props) $$invalidate(0, video = $$props.video);
		if ('show_category' in $$props) $$invalidate(1, show_category = $$props.show_category);
	};

	return [video, show_category, isHovered, formatDate, hover, hoverExit];
}

class Video extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { video: 0, show_category: 1 });
	}
}

export default Video;